import React, { memo, useEffect, useRef, useState, } from 'react';
import { Animated, View, } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
import { ColorTokens, BorderRadiusTokens, SizeTypeTokens, } from '@voltmoney/schema';
const LinearProgressIndicatorBase = ({ size = 1, activeIndex = 0, count = 0, color = ColorTokens.Blue_600, borderRadius = BorderRadiusTokens.BR4, height = SizeTypeTokens.MD, }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const borderRadiusValue = theme.borderRadius[borderRadius];
    const heightValue = theme.space[height];
    const counter = useRef(new Animated.Value(0)).current;
    const countInterval = useRef(null);
    const [countX, setCount] = useState(count);
    useEffect(() => {
        countInterval.current = setInterval(() => setCount((old) => old + 5), 1000);
        return () => {
            //  clearInterval(countInterval);
        };
    }, []);
    useEffect(() => {
        load(countX);
        if (countX >= 100) {
            setCount(100);
            //  clearInterval(countInterval);
        }
    }, [countX]);
    const load = (countX) => {
        Animated.timing(counter, {
            toValue: countX,
            duration: 500,
            useNativeDriver: false,
        }).start();
    };
    const inputRange = [0, 100];
    const outputRange = ['0%', '100%'];
    const animatedWidth = counter.interpolate({
        inputRange,
        outputRange,
    });
    return (React.createElement(View, { style: {
            flex: 1,
            height: heightValue,
            borderRadius: borderRadiusValue,
            backgroundColor: colorMapping[color],
        } },
        React.createElement(View, { style: {
                height: heightValue,
                flexDirection: 'row',
                width: '100%',
                backgroundColor: '#F3FAF6',
                borderRadius: borderRadiusValue,
            } },
            React.createElement(Animated.View, { style: {
                    backgroundColor: '#8BED4F',
                    width: animatedWidth,
                } }))));
};
export default memo(LinearProgressIndicatorBase);
export { LinearProgressIndicatorBase };
